import { EXPORTACION_TYPES } from "../constants/exportacion.types";
import { ExportacionAction, ExportacionInitialState, ExportacionState } from "../interfaces/dte-exportacion.interface";

const initalState: ExportacionInitialState = {
    datosFactura: {}
}

const exportacionReducer = (
    state: ExportacionInitialState = initalState,
    action: ExportacionAction
): ExportacionState => {
    switch(action.type){
        case EXPORTACION_TYPES.EXPORTACION_SET_DATA_FACTURA:
            return {...state, datosFactura: action.payload}
        default:
            return state
    }
}

export default exportacionReducer